import React, {useContext, useEffect, useState} from 'react'
import {RecipeUpdateContext} from "../../../../../context/RecipeUpdateContext";
import {Col, Row} from "antd";

const IngredientsMidValue = () => {
    const [total, setTotal] = useState()
    const {subTotals} = useContext(RecipeUpdateContext)

    useEffect(() => {
        setTotal(subTotals)
    }, [subTotals])

    return(
        <React.Fragment>
            <Row justify={"end"} align={"start"}>
                <Col span={15}>
                    <h6>Malzeme Giderleri Alt Toplam :</h6>
                </Col>
                <Col span={5}>
                    {
                        <span>{new Intl.NumberFormat().format(total)} USD</span>
                    }
                </Col>
            </Row>
        </React.Fragment>
    )
}
export default IngredientsMidValue